import React from "react";
import { Confirmation } from "../../../secondary";
import { useSelector } from "react-redux";
import Loader from "../../../../static/images/spinner.svg";
import warning from "../../../../static/images/icon-check-danger.png";
import constants from "../../../../constants/constants.json";
import { Button } from "../../../primary";
import style from "../assessmentNotes.module.scss";

const NotesDeleteConfirmationModal = ({ setDeleteModal, handleDelete }) => {
  const deleteAssessmentNoteLoading = useSelector((state) => state.patient.deleteAssessmentNoteLoading);
  return (
    <Confirmation onClose={() => setDeleteModal(false)} title={" "}>
      <div className="text-center pr-5 pl-5">
        <p>
          {deleteAssessmentNoteLoading ? (
            <div className="loader p-0">
              <img src={Loader} alt="loading" />
            </div>
          ) : (
            <img src={warning} alt="warnning-icon" />
          )}
        </p>
        <p className="pb-3">{constants.deleteConfirmation}</p>
        <div className="mb-2">
          <Button value="Yes" classes={{ className: `btn mr-2 pb-2 pt-2 mr-3 ${style.btn_primary}` }} onClick={handleDelete} />
          <Button value="No" classes={{ className: `btn ml-2 pb-2 pt-2 ${style.btn_scondary}` }} onClick={() => setDeleteModal(false)} />
        </div>
      </div>
    </Confirmation>
  );
};

export default NotesDeleteConfirmationModal;
